module.exports = __webpack_public_path__ + "img/welding-7.0f733c67.jpg";